import validator from 'validate.js';
import { validationPatterns } from '../modules/global/validationPatterns'

const defaultOptions = {
  fullMessages: false,    // prevent prepending field name to messages
};

const constraints = {
  postalCode: {
    presence: true,
    format: {
      pattern: /^\\d{5}$/,
    },
  },
};


export const validate = (attributes) => validator.validate(attributes, constraints, defaultOptions);

export const validateSingle = (value, constraint) => validator.single(value, constraint, defaultOptions);

const isValid = (str, constraint) => {
	const error = validateSingle(str, constraint);
	return (error === undefined);
}

export const isNotEmpty = (str) => {
    return isValid(str, {
		presence: true,
		format: {
			pattern: validationPatterns.notEmpty,
		}
	});
};

export const isNotEmptyLengthUnder50 = (str) => {
	return str.length < 50 && isNotEmpty(str);
};

export const isValidInteger = (value) => {
	const regex = /(^[0-9]+$)/;
	return value.match(regex);
}

export const isNotEmptyEmailWithLengthUnder80 = (email) => {
	return email.length < 80 && isNotEmpty(email) && isValidEmail(email);
};

export const isValidEmail = (email) => {
	return isValid(email, {
		email: true,
	});
};

const isValidSsnSyntax = (ssn) => {
	return isValid(ssn, {
		presence: true,
		format: {
			pattern: validationPatterns.hetu,
		}
	});
}

export const isValidPhoneNumber = (phoneNumber) => {
	return isValid(phoneNumber, {
		presence: true,
		format: {
			pattern: validationPatterns.phoneNumber
		}
	});
}

export const isValidBusinessId = (businessId) => {
	// aka Y-tunnus
	// Spec: http://tarkistusmerkit.teppovuori.fi/tarkmerk.htm#y-tunnus2
	const businessIdFormat = /^\d{7}-\d{1}/;    // Check 1234567-0 format with regexp

	if (String(businessId).length === 9 && String(businessId).match(businessIdFormat)) {
		const char1 = Number(businessId[0]) * 7;
		const char2 = Number(businessId[1]) * 9;
		const char3 = Number(businessId[2]) * 10;
		const char4 = Number(businessId[3]) * 5;
		const char5 = Number(businessId[4]) * 8;
		const char6 = Number(businessId[5]) * 4;
		const char7 = Number(businessId[6]) * 2;
		const sumModulo = (char1 + char2 + char3 + char4 + char5 + char6 + char7) % 11;
		const stringChecksum = Number(businessId[8]);

		if (sumModulo === 0 && sumModulo === Number(stringChecksum)) {
			return true;
		} else if (sumModulo === 1) {
			return false;
		} else if (sumModulo >= 2) {
			if ((11 - sumModulo) === Number(stringChecksum)) {
				return true
			}
		}
	}
	return false;
}

/***************************
 Finnish SSN validation:

 The format is DDMMYYSNNNT, where
 DDMMYY is birth date.
 S is, '-' or 'A', '-' indicates birthyear (YY) in 19xx, 'A' indicates 20xx
 NNN is an arbitrary number (length always 3), odd for men, even for women. Zero-prefixed if needed.
 T is checksum char from set '0123456789ABCDEFHJKLMNPRSTUVWXY', where indexOf char == checksum value

 Number(DDMMYYNNNN) mod 31 should equal to checksum character value.

 Spec from https://tarkistusmerkit.teppovuori.fi/tarkmerk.htm#hetu1
 ********************************/
export const isValidSsn = (ssn) => {
	const allowedCheckChars = '0123456789ABCDEFHJKLMNPRSTUVWXY';

	if (!isValidSsnSyntax(ssn)) {
		return false;
	}

	const expectedChecksumValue = allowedCheckChars.indexOf(ssn[10]);
	if (expectedChecksumValue === -1) {
		return false;
	}
	const numberPart = Number(ssn.substring(0, 6) + ssn.substring(7, 10));
	const checkSum = numberPart % 31;

	return checkSum === expectedChecksumValue;
}

const isUnderAged = (ssn) => {
	if (ssn.charAt(6) === '-') return false;
	let adultsBornAfterDate = new Date();
	adultsBornAfterDate.setFullYear(adultsBornAfterDate.getFullYear() - 18);
	const birthDateYear = parseInt("20" + ssn.substring(4, 6));
	const birthDateMonth = parseInt(ssn.substring(2, 4)) - 1;
	const birthDateDay = parseInt(ssn.substring(0, 2));
	const birthDate = new Date(birthDateYear,birthDateMonth,birthDateDay);
	return adultsBornAfterDate < birthDate;
}

export const isValidAdultSsn = (ssn) => {
	return isValidSsn(ssn) && !isUnderAged(ssn);
}

export default validate
